module.exports = __webpack_public_path__ + "img/westcampusdeck-h-474x356.0edb8f8a.jpg";